// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  cursor: pointer;
}
:host ::ng-deep .popover {
  font-size: 14px;
  max-width: 350px;
  width: 320px;
  right: 0;
}
:host ::ng-deep .popover > .arrow {
  right: 17px;
}
:host ::ng-deep .popover .popover-content {
  padding: 0;
}
:host .profile, :host .organization {
  padding: 8px 14px;
  border-top: 1px solid #ebebeb;
}
:host .profile:first-child, :host .organization:first-child {
  border-top: none;
}
:host .profile.media, :host .organization.media {
  margin-top: 0;
}
:host .organization .list-group {
  margin-top: 10px;
}
:host .buttons {
  margin: 0;
  padding: 8px 14px;
  border-top: 1px solid #ebebeb;
  background-color: #fff;
  border-radius: 0 0 5px 5px;
  background-color: #f7f7f7;
}
:host .profile .flex-grow-1, :host .organization .flex-grow-1 {
  min-width: 0;
}
:host .fix-width {
  max-width: 100%;
}
:host .fix-width.add-ellipsis {
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}`, "",{"version":3,"sources":["webpack://./src/app/U2000_workspace/U2000_workspace/U2000_header/U2000_profilebutton/U2000_profilebutton.component.scss"],"names":[],"mappings":"AAIA;EACI,eAAA;AAHJ;AAKI;EACI,eAAA;EACA,gBAAA;EACA,YAAA;EAEA,QAAA;AAJR;AAMQ;EAEI,WAAA;AALZ;AAQQ;EACI,UAAA;AANZ;AASI;EACI,iBAAA;EACA,6BAAA;AAPR;AASQ;EACI,gBAAA;AAPZ;AASQ;EACI,aAAA;AAPZ;AAYQ;EACI,gBAAA;AAVZ;AAcI;EACI,SAAA;EACA,iBAAA;EACA,6BAAA;EACA,sBAAA;EACA,0BAAA;EACA,yBAAA;AAZR;AAiBQ;EACI,YAAA;AAfZ;AAmBI;EACI,eAAA;AAjBR;AAkBQ;EACI,mBAAA;EACA,uBAAA;EACA,gBAAA;AAhBZ","sourcesContent":["\n@import \"../../../../U2000_style/U2000_style-mixins\";\n@import \"../../../../U2000_style/U2000_style-variables\";\n\n:host {\n    cursor: pointer;\n\n    ::ng-deep .popover {\n        font-size: 14px;\n        max-width: 350px;\n        width: 320px;\n        // left: inherit!important;\n        right: 0;\n\n        >.arrow {\n            // left: inherit!important;\n            right: 17px;\n        }\n\n        .popover-content {\n            padding: 0;\n        }\n    }\n    .profile,.organization {\n        padding: 8px 14px;\n        border-top: 1px solid #ebebeb;\n\n        &:first-child {\n            border-top: none;\n        }\n        &.media {\n            margin-top: 0;\n        }\n    }\n\n    .organization {\n        .list-group {\n            margin-top: 10px;\n        }\n    }\n\n    .buttons {\n        margin: 0;\n        padding: 8px 14px;\n        border-top: 1px solid #ebebeb;\n        background-color: #fff;\n        border-radius: 0 0 5px 5px;\n        background-color: #f7f7f7;\n    }\n\n    // Flex (Bootstrap 5) : sans min-width: 0, la colonne de texte ne retrecit pas sous son contenu et le lien depasse du popover.\n    .profile,.organization {\n        .flex-grow-1 {\n            min-width: 0;\n        }\n    }\n\n    .fix-width {\n        max-width: 100%;\n        &.add-ellipsis {\n            white-space: nowrap;\n            text-overflow: ellipsis;\n            overflow: hidden;\n        }\n    }\n\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
